import { EffectCallback, useState } from "react";

const arraysEqual = <T,>(a: T[], b: T[]): boolean => {
  if (a.length !== b.length) {
    throw new Error("Array length should stay same between renders for 'useWatchDependency' hook");
  }
  return a.every((val, index) => val === b[index]);
};

export const useWatchDependency = <T,>(callback: EffectCallback, dependencyArray: T[]) => {
  const [prevArray, setPrevArray] = useState<T[] | null>(null);
  const [unmountCallback, setUnmountCallback] = useState<(() => void) | null>(null);

  if (prevArray === null || !arraysEqual(dependencyArray, prevArray)) {
    unmountCallback?.();
    setPrevArray(dependencyArray);
    const callbackResponse = callback();
    setUnmountCallback(callbackResponse ?? null);
  }
};
